export default "__VITE_ASSET__0b459df1__"